import React, { useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import BlogsDetails from "../blogdetails.js";
import BlogSidebar from "../blogSidebar.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";

function BlogNaturalBirthdayCakesChennai() {
  const [showSidebar, setShowSidebar] = useState(false);

  const handleClick = () => {
    window.open("https://wheatbakes.com/menu", "_blank");
  };

  return (
    <Container className="blog-page mt-4">
      <Row>
        {/* Sidebar */}
        <Col md={1} className={`blog-sidebar ${showSidebar ? "show" : "hide"}`}>
          <BlogSidebar
            blogs={BlogsDetails}
            closeSidebar={() => setShowSidebar(!showSidebar)}
            active={"natural-birthday-cakes-in-chennai"}
          />
        </Col>

        {/* Main Content */}
        <Col md={12} className="blog-content">
          {/* Toggle button */}
          <div
            onClick={() => setShowSidebar(!showSidebar)}
            className="blogs-sidebar-open mb-3"
            >
            <FontAwesomeIcon
                icon={faBars}
                className="blogs-sidebar-close-icon me-2"
            />
            View Other Blogs
          </div>

          {/* INTRO SECTION */}
          <div className="row">
            <div
                className="col-lg-6 col-xl-6 col-sm-12 my-2 order-2 order-lg-1"
              data-aos="fade-left"
            >
              <h2 className="brown-text-color text-bold-600">
                Natural Birthday Cakes in Chennai: What to Look For
              </h2>

              <p className="wheatbakes-para-justify">
                Birthday celebrations are moments of joy, togetherness, and
                indulgence. But today, more families are looking beyond just
                appearance and taste — they want cakes that are natural, safer,
                and made with clean ingredients. If you’re searching for{" "}
                <span className="fw-semibold">
                  natural birthday cakes in Chennai,
                </span>{" "}
                knowing what to look for can help you make the right choice.
              </p>

              <p className="wheatbakes-para-justify">
                At <span className="fw-semibold">WheatBakes</span>, we believe
                birthdays should be celebrated with cakes that are delicious,
                wholesome, and suitable for everyone, from children to seniors.
              </p>
            </div>

            <div
              className="col-lg-6 col-xl-6 col-sm-12 my-2 order-1 order-lg-2"
              data-aos="fade-right"
            >
              <img
                src="/images/home/plaincake.png"
                alt="Natural Birthday Cakes in Chennai"
                className="img-fluid rounded w-100"
              />
            </div>

            
          </div>

          {/* WHY NATURAL */}
          <div>
          <h2 className="brown-text-color">Why Choose Natural Birthday Cakes?</h2>
          <p className="wheatbakes-para-justify">
            Conventional birthday cakes often contain refined flour, artificial
            flavors, excess sugar, and preservatives. Natural cakes, on the
            other hand:
          </p>

          <ul>
            <li>Use cleaner, real ingredients.</li>
            <li>They are easier to digest</li>
            <li>Offer balanced sweetness</li>
            <li>Support healthier eating habits.</li>
          </ul>

          <p className="wheatbakes-para-justify">
            Choosing natural cakes ensures your celebrations are joyful without
            unnecessary compromises on health.
          </p>
          </div>

          {/* WHAT TO LOOK FOR */}
          <h2 className="brown-text-color">
            What to Look For in Natural Birthday Cakes
          </h2>

          {/* CARD SECTION */}
          <Row className="my-4 g-4">

            <Col md={6}>
              <Card className="h-100 shadow-sm border-1 p-3">
                <Card.Body>
                  <h5 className="fw-bold brown-text-color">
                    1. Eggless Whole Wheat Cakes
                  </h5>
                  <p>
                  One of the most important factors is the base ingredient. <a className="brown-text-color" href="https://wheatbakes.com/whole-wheat-cakes" rel="noreferrer" target="_blank">Eggless whole wheat cakes</a>
                  </p>
                  <ul>
                    <li>Contains natural fiber</li>
                    <li>Are suitable for vegetarian families</li>
                    <li>Are gentler on digestion</li>
                  </ul>
                  <p className="mb-0">
                    They are ideal for birthday parties where guests have
                    diverse dietary preferences.
                  </p>
                </Card.Body>
              </Card>
            </Col>

            <Col md={6}>
              <Card className="h-100 shadow-sm border-1 p-3">
                <Card.Body>
                  <h5 className="fw-bold brown-text-color">
                    2. Low Sugar Natural Cakes
                  </h5>
                  <p>Excess sugar can lead to energy crashes, especially in children. <span className="fw-semibold">Low sugar natural cakes:</span></p>
                  <ul>
                    <li>Reduce sudden sugar spikes.</li>
                    <li>Offer a more balanced taste.</li>
                    <li>Are suitable for regular celebrations</li>
                  </ul>
                  <p className="mb-0">
                    A naturally sweetened cake allows everyone to enjoy an
                    extra slice without guilt.
                  </p>
                </Card.Body>
              </Card>
            </Col>

            <Col md={6}>
              <Card className="h-100 shadow-sm border-1 p-3">
                <Card.Body>
                  <h5 className="fw-bold brown-text-color">
                    3. Absence of Artificial Additives
                  </h5>
                  <p>A truly natural birthday cake should avoid:</p>
                  <ul>
                    <li>Artificial colors</li>
                    <li>Synthetic flavors</li>
                    <li>Chemical preservatives</li>
                  </ul>
                  <p className="mb-0">
                    Always choose bakeries that focus on clean-label baking and
                    transparency.
                  </p>
                </Card.Body>
              </Card>
            </Col>

            <Col md={6}>
              <Card className="h-100 shadow-sm border-1 p-3">
                <Card.Body>
                  <h5 className="fw-bold brown-text-color">
                    4. Fresh, Made-to-Order Baking
                  </h5>
                  <p>Local bakeries in Chennai often provide fresher products. Cakes made to order:</p>
                  <ul>
                    <li>Taste better</li>
                    <li>Retain moisture naturally</li>
                    <li>Do not rely on preservatives</li>
                  </ul>
                  <p className="mb-0">
                    This is a key sign of a bakery committed to quality.
                  </p>
                </Card.Body>
              </Card>
            </Col>
            
            <Col md={6}>
                <Card className="h-100 shadow-sm border-1 p-3">
                  <Card.Body>
                    <h5 className="fw-bold brown-text-color">
                    5. Suitable for All Age Groups
                    </h5>
                    <p>The best birthday cakes are those that everyone can enjoy. Natural cakes made with whole wheat and low sugar are:</p>
                    <ul>
                    <li>Safe for children</li>
                    <li>Easier for elders to digest</li>
                    <li>Perfect for family celebrations</li>
                    </ul>
                    
                  </Card.Body>
                </Card>
            </Col>
          </Row>

          <br></br>
          {/* WHY WHEATBAKES */}
          <h2 className="brown-text-color">
            Why WheatBakes Is a Trusted Choice in Chennai
          </h2>
          <p><span className="fw-semibold">WheatBakes</span> is known for creating cakes that balance celebration with wellness. We specialize in:</p>
          <ul>
            <li>Eggless whole wheat cakes</li>
            <li>Carefully crafted low sugar natural cakes</li>
            <li>Clean, preservative-free baking</li>
            <li>
              Cakes designed for birthdays, kids’ parties, and family gatherings
            </li>
          </ul>

          <p>
          Every cake is made with care, keeping health, taste, and happiness in mind.{" "}
            <a
              href="https://wheatbakes.com/menu"
              target="_blank"
              rel="noreferrer"
              className="brown-text-color"
            >
              Explore our range of natural birthday cakes here
            </a>
          </p>

          {/* FINAL */}
          <h2 className="brown-text-color">Final Thoughts</h2>
          <p className="wheatbakes-para-justify">
            When choosing <span className="fw-semibold">natural birthday cakes in Chennai,</span> focus on
            ingredients, sugar levels, and baking philosophy — not just
            decoration. Cakes made with whole wheat, low sugar, and natural
            ingredients make celebrations more meaningful and healthier.
          </p>

          <p className="wheatbakes-para-justify">
            With <span className="fw-semibold">WheatBakes</span>, you can
            celebrate birthdays the natural way — full of joy, flavor, and
            goodness in every slice.
          </p>

          {/* CTA */}
          <div className="my-5 text-center">
            <button className="wheatbakes-btn" onClick={handleClick}>
              ORDER NATURAL BIRTHDAY CAKES
            </button>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default BlogNaturalBirthdayCakesChennai;
